import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";

/**
 * Flat rounded rect for containing content
 */

type CardProps = React.PropsWithChildren<{
  style?: ThemeUIStyleObject;
  className?: string;
}>;

export default function Card({ style, className, children }: CardProps) {
  return (
    <div sx={{ ...defaultStyle, ...style }} className={className}>
      {children}
    </div>
  );
}

const defaultStyle: ThemeUIStyleObject = {
  padding: RAW_cssValue(56),
  borderRadius: "dt_radius_m",
  textAlign: "left",
  backgroundColor: "dt_background_primary",
  color: RAW_cssValue("#3e425d"),
};
